import { render, staticRenderFns } from "./Teamarchives.vue?vue&type=template&id=662c0262&scoped=true"
import script from "./Teamarchives.vue?vue&type=script&lang=js"
export * from "./Teamarchives.vue?vue&type=script&lang=js"
import style0 from "./Teamarchives.vue?vue&type=style&index=0&id=662c0262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662c0262",
  null
  
)

export default component.exports